/* tslint:disable */
/* eslint-disable */
/**
 * Web App core API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { IssueEntry } from './IssueEntry';
import {
    IssueEntryFromJSON,
    IssueEntryFromJSONTyped,
    IssueEntryToJSON,
} from './IssueEntry';
import type { Page } from './Page';
import {
    PageFromJSON,
    PageFromJSONTyped,
    PageToJSON,
} from './Page';

/**
 * 
 * @export
 * @interface PageableIssueEntries
 */
export interface PageableIssueEntries {
    /**
     * 
     * @type {Array<IssueEntry>}
     * @memberof PageableIssueEntries
     */
    result: Array<IssueEntry>;
    /**
     * 
     * @type {Page}
     * @memberof PageableIssueEntries
     */
    page: Page;
}

/**
 * Check if a given object implements the PageableIssueEntries interface.
 */
export function instanceOfPageableIssueEntries(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "result" in value;
    isInstance = isInstance && "page" in value;

    return isInstance;
}

export function PageableIssueEntriesFromJSON(json: any): PageableIssueEntries {
    return PageableIssueEntriesFromJSONTyped(json, false);
}

export function PageableIssueEntriesFromJSONTyped(json: any, ignoreDiscriminator: boolean): PageableIssueEntries {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'result': ((json['result'] as Array<any>).map(IssueEntryFromJSON)),
        'page': PageFromJSON(json['page']),
    };
}

export function PageableIssueEntriesToJSON(value?: PageableIssueEntries | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'result': ((value.result as Array<any>).map(IssueEntryToJSON)),
        'page': PageToJSON(value.page),
    };
}

